<template>
  <div class="">
    <div class="container p-0">
      <ul class="step clearfix">
        <li :class="{active: stepPass(0) === 1}" @click="go(0)"><span class="step-item">1. เลือกจำนวนเงิน</span></li>
        <li :class="{active: stepPass(1) > 1}" @click="go(1)"><span class="step-item">2. ช่องทางการชำระเงิน</span></li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DonateStepBar',
  methods: {
    stepPass (idx) {
      const routeName = this.$route.name
      return {
        'pages': 1,
        'checkout': 2
      }[routeName]
    },
    go (idx) {
      this.$emit('clickstep', idx)
    }
  }
}
</script>



// WEBPACK FOOTER //
// DonateStepBar.vue?5c30ba2e